import React, { Component } from 'react'
import { Table } from "antd"
import { observer, inject } from "mobx-react"
import moment from 'moment'

@inject("auth") @observer
export default class DataTable extends Component {
  componentDidMount() {
    const { getTimingTaskData } = this.props.store
    getTimingTaskData()
  }

  render() {
    const {
      store: {
        timingTaskData,
      },
    } = this.props
    const startTime = timingTaskData.startTime && moment(timingTaskData.startTime).format('YYYY-MM')
    const endTime = timingTaskData.endTime && moment(timingTaskData.endTime).subtract(1, 'months').format('YYYY-MM')
    
    let softResultStatisticsCopy, reviewResultStatisticsCopy, sdResultStatisticsCopy
    
    if (timingTaskData && timingTaskData.softResultStatistics) {
      softResultStatisticsCopy = timingTaskData.softResultStatistics
        .filter((soft, index) => index !== 0)
    }

    if (timingTaskData && timingTaskData.reviewResultStatistics) {
      reviewResultStatisticsCopy = timingTaskData.reviewResultStatistics.filter((soft, index) => index !== 0)
    }

    if (timingTaskData && timingTaskData.sdResultStatistics) {
      sdResultStatisticsCopy = timingTaskData.sdResultStatistics
    }

    const columns = [{
      title: 'PGS',
      className: 'ta-c',
      key: 'pgta',
      children: [{
        title: "名称",
        className: "ta-l",
        dataIndex: "pgtaName",
        key: "pgtaName",
        render: (text) => {
          return (
            <div className={text.indexOf('-') !== -1 ? 'ele-empty' : ''} >
              {text}
            </div>
          )
        }
      }, {
        title: "数量",
        className: "ta-r",
        dataIndex: "pgtaCount",
        key: "pgtaCount",
      }, {
        title: "百分比",
        className: "ta-r",
        dataIndex: "pgtaPercent",
        key: "pgtaPercent",
      }]
    }, {
      title: 'gDNA CNV-seq',
      className: 'ta-c',
      key: 'gcnv',
      children: [{
        title: "名称",
        className: "ta-l",
        dataIndex: "gdnaName",
        key: "gdnaName",
        render: (text) => {
          return (
            <div className={text.indexOf('-') !== -1 ? 'ele-empty' : ''} >
              {text}
            </div>
          )
        }
      }, {
        title: "数量",
        className: "ta-r",
        dataIndex: "gdnaCount",
        key: "gdnaCount",
      }, {
        title: "百分比",
        className: "ta-r",
        dataIndex: "gdnaPercent",
        key: "gdnaPercent",
      }]
    }]

    const sdColumns = [{
      title: "APP",
      className: "ta-l",
      dataIndex: "appName",
    }, {
      title: "样本量",
      className: "ta-r",
      dataIndex: "total",
    }, {
      title: "SD均值",
      className: "ta-r",
      dataIndex: "average",
    }, {
      title: "SD≤2.5",
      className: "ta-r",
      dataIndex: "small",
    }, {
      title: "2.5<SD≤3.5",
      className: "ta-r",
      dataIndex: "medium",
    }, {
      title: "SD>3.5",
      className: "ta-r",
      dataIndex: "large",
    }]

    return (
      <div className="table-wrapper-box">
        <span className="statistics-table-title">
          {startTime}{timingTaskData.startTime ? '~' : ''}{endTime} 软件结果统计
        </span>
        <Table
          rowKey={(record) => record.id}
          bordered
          columns={columns}
          dataSource={softResultStatisticsCopy ? softResultStatisticsCopy.slice() : []}
          pagination={false}
        />

        <span className="statistics-table-title">
          {startTime}{timingTaskData.startTime ? '~' : ''}{endTime} 人工审核结果统计
        </span>
        <Table
          rowKey={record => record.id}
          bordered={true}
          columns={columns}
          dataSource={reviewResultStatisticsCopy ? reviewResultStatisticsCopy.slice() : []}
          pagination={false}
        />
        
        <span className="statistics-table-title">{startTime}
          {timingTaskData.startTime ? '~' : ''}{endTime} SD统计
        </span>

        <Table
          rowKey={record => record.id}
          bordered={true}
          columns={sdColumns}
          dataSource={sdResultStatisticsCopy ? sdResultStatisticsCopy.slice() : []}
          pagination={false}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/timingTask/container/DataTable.js